var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentPosting(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 74 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9062 0.291992H10.0938C3.5625 0.291992 0.28125 3.54199 0.28125 9.97949V12.8857H73.7188V9.97949C73.7188 3.54199 70.4688 0.291992 63.9062 0.291992ZM13.0625 43.9795C11.2188 43.9795 10 42.7295 10 40.9795V35.1982C10 33.417 11.2188 32.1982 13.0625 32.1982H20.7188C22.5625 32.1982 23.7812 33.417 23.7812 35.1982V40.9795C23.7812 42.7295 22.5625 43.9795 20.7188 43.9795H13.0625ZM10.0938 53.667H63.9062C70.4688 53.667 73.7188 50.4482 73.7188 44.0107V19.9795H0.28125V44.0107C0.28125 50.4482 3.5625 53.667 10.0938 53.667Z",
    fill: "#31425A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPosting);
export default __webpack_public_path__ + "static/media/payment-posting.a26317d4.svg";
export { ForwardRef as ReactComponent };